import tw, { styled } from 'twin.macro'

import { focusStyles } from '../sharedStyles'

export const StyledNav = tw.nav`space-y-6 flex flex-col h-full`

// Not really sure if we should use <section> here instead of a div
// but MDN is inconclusive about sections inside navs
export const Section = tw.div`space-y-2`

export const StyledAnchor = styled.a<{ isActive?: boolean }>(({ isActive }) => [
  focusStyles,
  tw`
    font-brand
    font-normal
    text-sm-brand
    no-underline
    text-default-emphasis
    flex
    items-center
    p-2
    rounded-md
    outline-none
    cursor-pointer
    hover:bg-default-muted
  `,
  isActive &&
    tw`
      font-bold
      text-brand-emphasis
      bg-brand-subdued
      hover:bg-brand-subdued
  `,
])

export const SectionLabel = tw.div`
  font-brand
  font-normal
  text-xs-brand
  text-default-muted
  p-2
`
